import { render } from "./PendingCaseView.vue?vue&type=template&id=5d890dfa"
import script from "./PendingCaseView.vue?vue&type=script&lang=js"
export * from "./PendingCaseView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/PendingCaseView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d890dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d890dfa', __exports__)) {
    console.log('reload')
    api.reload('5d890dfa', __exports__)
  }
  
  module.hot.accept("./PendingCaseView.vue?vue&type=template&id=5d890dfa", () => {
    console.log('re-render')
    api.rerender('5d890dfa', render)
  })

}


export default __exports__